/**
 * Collection cards stagger-reveal as the grid scrolls into view.
 */
import { revealOnScroll } from '@theme/premium-motion';

revealOnScroll('.flv-collections-index__card', { y: 24, scale: 0.97, duration: 0.6, stagger: 0.05 });
